var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.items && _vm.items.length
    ? _c("div", { staticClass: "key-topics" }, [
        _c("div", { staticClass: "container" }, [
          _c("h2", { domProps: { innerHTML: _vm._s(_vm.title) } }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row row--20" },
            _vm._l(_vm.items, function(item, index) {
              return _c(
                "div",
                {
                  key: index,
                  class: [
                    item["big-format"]
                      ? "col-default-8 col-mobile-12"
                      : "col-default-4 col-mobile-12"
                  ]
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "key-topics__card",
                      attrs: {
                        href: item.link,
                        target: [item["external-link"] ? "_blank" : "_self"],
                        "data-target": "KeyTopics" + (index + 1) + "MainPage",
                        "data-label": "keytopic" + (index + 1),
                        "data-category": "keytopics"
                      },
                      on: {
                        click: function($event) {
                          if ($event.target !== $event.currentTarget) {
                            return null
                          }
                          return _vm.targetAnalytics($event)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "key-topics__card-wrapper",
                          style: _vm.styleHelperImage(item)
                        },
                        [
                          _c("span", {
                            staticClass: "key-topics__card--caption",
                            domProps: { innerHTML: _vm._s(item.type) }
                          }),
                          _vm._v(" "),
                          _c("p", {
                            staticClass: "key-topics__card--title",
                            class: {
                              "key-topics__card--link-external":
                                item["external-link"]
                            },
                            domProps: { innerHTML: _vm._s(item.name) }
                          }),
                          _vm._v(" "),
                          item.detail
                            ? _c(
                                "div",
                                {
                                  staticClass: "key-topics__card--description"
                                },
                                [
                                  _c("span", {
                                    staticClass: "key-topics__spacer"
                                  }),
                                  _vm._v(" "),
                                  _c("div", {
                                    domProps: { innerHTML: _vm._s(item.detail) }
                                  })
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ]
                  )
                ]
              )
            }),
            0
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-658e1648", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-658e1648","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./frontend/components/main-page/components/key-topics/index.vue
// module id = 111
// module chunks = 0